import { Sync } from 'models/index';
import { endpoint, EndpointError } from '../endpoint';

export type SyncParams = void;
export type SyncResult = { hotels: Sync.Model[] };
export type SyncError = EndpointError;

export const syncAll = endpoint<SyncParams, SyncResult, SyncError>({
  method: 'GET',
  url: () => `/sync-all`,
});
